import * as React from 'react';
import { LayerManager } from '../layers/LayerManager';
import { System } from '../System';
import { ErrorDialog, ErrorDialogProps } from '../widgets/dialog/ErrorDialog';
import { ConfirmDialog, ConfirmDialogProps } from '../widgets/dialog/ConfirmDialog';

export class DialogStore {
  private layerManager: LayerManager;

  constructor(system: System) {
    this.layerManager = system.layerManager;
  }

  async errorDialog(event: ErrorDialogProps) {
    return new Promise<void>((resolve) => {
      this.layerManager.showLayer({
        withBackdrop: true,
        render: (renderEvent) => {
          return (
            <ErrorDialog
              {...event}
              onContinue={() => {
                event.onContinue?.();
                renderEvent.layer.dispose();
                resolve();
              }}
            />
          );
        }
      });
    });
  }

  async confirmDialog(event: Omit<ConfirmDialogProps, 'onCancel' | 'onConfirm'>) {
    return new Promise<boolean>((resolve) => {
      this.layerManager.showLayer({
        withBackdrop: true,
        render: (renderEvent) => {
          return (
            <ConfirmDialog
              {...event}
              onConfirm={() => {
                resolve(true);
                renderEvent.layer.dispose();
              }}
              onCancel={() => {
                resolve(false);
                renderEvent.layer.dispose();
              }}
            />
          );
        }
      });
    });
  }

  async infoDialog(event: Omit<ConfirmDialogProps, 'onCancel' | 'onConfirm'>) {
    return new Promise<boolean>((resolve) => {
      this.layerManager.showLayer({
        withBackdrop: true,
        render: (renderEvent) => {
          return (
            <ConfirmDialog
              {...event}
              isInfoDialog={true}
              onConfirm={() => {
                resolve(true);
                renderEvent.layer.dispose();
              }}
            />
          );
        }
      });
    });
  }
}
